<div class="tab">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab *ngFor="let tab of tabs; let i = index">
            <ng-template mat-tab-label>
                <img [src]="tab.imgSrc" class="h-6 w-6" />
                {{tab.title}}
            </ng-template>
            <ng-content  [selector]="'slot' + i" ></ng-content>
            <!-- <ng-content  [selector]="'[slot' + i + ']'"></ng-content> -->
            <!-- <ng-template matTabContent> -->
            <!-- </ng-template> -->
        </mat-tab>
    </mat-tab-group>
</div>
